// extracted by mini-css-extract-plugin
module.exports = {"wrap":"FirebaseAlert_wrap_2QW9W","bg":"FirebaseAlert_bg_2prbq","content":"FirebaseAlert_content_1tFnz","message":"FirebaseAlert_message_3z9uR","btn":"FirebaseAlert_btn_1aQ23"};